import { PATHS } from "@/lib/router";
import { CustomFrameworkListPage } from "./pages/CustomFrameworkListPage";
import { CustomFrameworkBuilderPage } from "./pages/CustomFrameworkBuilderPage";

export const customFrameworkRoutes = [
  {
    path: PATHS.CUSTOM_FRAMEWORK_LIST,
    element: <CustomFrameworkListPage />,
    handle: {
      permission: { resource: "custom_framework", action: "view" },
      companyFeatureFlag: "customFrameworkEnabled",
    },
  },
  {
    path: PATHS.CUSTOM_FRAMEWORK_BUILDER,
    element: <CustomFrameworkBuilderPage />,
    handle: {
      permission: { resource: "custom_framework", action: "update" },
      companyFeatureFlag: "customFrameworkEnabled",
    },
  },
];
